import Image from 'next/image';
import { render } from 'storyblok-rich-text-react-renderer';
import React from 'react';
import Link from 'next/link';
import { DAVINCI_CDN } from '@/app/_constants/defaultValues';
import { makeRichTextRenderOptions } from '@/storyblok/utils/richText';
import { resolveWebLink } from '@/storyblok/utils/link';
import { FooterWrapperComponentProps } from '@/app/_components/layouts/footer/types';
import clsx from 'clsx';

const FooterBottom: React.FC<FooterWrapperComponentProps> = ({ component: footer, story, minimal, theme }) => {
  const ELTY_LOGO = `${DAVINCI_CDN}/elty/elty-logo${theme === 'dark' ? '-white' : ''}.svg`;
  const UNIPOL_LOGO = `${DAVINCI_CDN}/elty/unipol-logo${theme === 'dark' ? '-white' : ''}.svg`;

  return (
    <footer
      className={clsx(
        'w-full px-4 py-12 xl:px-20',
        theme === 'dark' && 'bg-primary text-white',
        theme === 'light' && 'bg-white text-primary',
      )}
    >
      <div className="flex w-full flex-col items-start justify-between justify-between gap-4 lg:flex-row lg:items-center xl:mx-auto xl:max-w-screen-xl">
        {minimal ? (
          <Image src={ELTY_LOGO} width={108} height={37} alt="Elty logo" />
        ) : (
          <>
            <Image src={UNIPOL_LOGO} width={80} height={32} alt="Unipol logo" />

            <div className={clsx('flex flex-col gap-4 text-xs lg:mb-0 lg:hidden [&>p]:leading-[1.125rem]')}>
              {render(footer.legalText, makeRichTextRenderOptions(story))}
            </div>
          </>
        )}

        <div className={clsx('text-xs font-medium', theme === 'light' && 'text-[#627282]')}>
          <span className="whitespace-break-spaces">{footer.bottomText}</span>
          <nav className="inline">
            <ul className="inline" role="menu">
              {footer.legal?.map(link => (
                <React.Fragment key={link._uid}>
                  <li className="inline px-1" role="separator">
                    |
                  </li>
                  <li role="presentation" className="inline">
                    {link.link && (
                      <Link
                        role="menuitem"
                        href={resolveWebLink(link.link, {
                          additional: { name: 'footer legals link item', link },
                          story,
                          component: footer,
                        })}
                      >
                        {link.title}
                      </Link>
                    )}
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default FooterBottom;
